import * as React from "react"
import { SvgComponentProps } from "../types/SVGPropType"
const SecuritySVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ? props.width : 17}
    height={props.width ? props.width : 17}
    fill="none"
    viewBox="0 0 17 17"
    {...props}
  >
    <path
      stroke="#A1A1A1"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.91 5.22v-.75c-1.9-.633-5.25-.91-5.25-3.5 0 2.59-3.35 2.867-5.25 3.5v6.028a4.5 4.5 0 0 0 2.412 3.986l1.338.701"
    />
    <path
      stroke="#A1A1A1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M12.16 16.346a3.875 3.875 0 1 0 0-7.75 3.875 3.875 0 0 0 0 7.75Z"
    />
    <path fill="#000" d="M8.66 12.47h7.25-7.25Z" />
    <path stroke="#A1A1A1" strokeLinejoin="bevel" d="M8.66 12.47h7.25" />
    <path fill="#000" d="M11.412 15.97a12.74 12.74 0 0 1 0-7v7Z" />
    <path
      stroke="#A1A1A1"
      strokeLinejoin="bevel"
      d="M11.412 15.97a12.74 12.74 0 0 1 0-7"
    />
    <path fill="#000" d="M12.91 15.97a12.74 12.74 0 0 0 0-7v7Z" />
    <path
      stroke="#A1A1A1"
      strokeLinejoin="bevel"
      d="M12.91 15.97a12.74 12.74 0 0 0 0-7"
    />
  </svg>
)
export default SecuritySVG
